import React, { Component } from 'react';

import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
   
import Home from './components';
import About from './components/about';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import JoinAsDealer from './components/JoinAsDealer';
import AuthorizedDealers from './components/AuthorizedDealers';
import SalesPartner from './components/SalesPartner';
import Client_list from './components/Client_list';
import Payment from './components/PaymentStatic';
//class App extends Component {
 // render(){
    function App() {
    return (
      <Router>
    <Routes>
        <Route exact path='/' element={<Home/>} />
        <Route path='/about' element={<About/>} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/testimonial' element={<Testimonial/>}/>
        <Route path='/privacypolicy' element={<PrivacyPolicy/>} />
        <Route path='/join-as-dealer' element={<JoinAsDealer/>} />
        <Route path='/authorized-dealers' element={<AuthorizedDealers/>} />
        <Route path='/salespartner' element={<SalesPartner/>} />
        <Route path='/clientlist' element={<Client_list/>} />
        <Route path='/payment' element={<Payment/>} />
    </Routes>
    </Router>
    );
 // }
  }

export default App;
